import { ErrorContext } from "../ErrorBoundary";
import opn from "../../util/opn";
import { Tag } from "bbcode-to-react";
import * as React from "react";
class LinkTag extends Tag {
    toHTML() {
        let linkUrl = this.renderer.strip(this.params[this.name] || this.getContent(true));
        if (/javascript:/i.test(linkUrl)) {
            linkUrl = "";
        }
        if (!linkUrl || !linkUrl.length) {
            return this.getContent();
        }
        return this.renderer.context({ linkify: false }, () => [
            `<a href="${linkUrl}" target="_blank" title="${linkUrl}">`,
            this.getContent(),
            "</a>",
        ]);
    }
    toReact() {
        let linkUrl = this.renderer.strip(this.params[this.name] || this.getContent(true));
        if (/javascript:/i.test(linkUrl)) {
            linkUrl = "";
        }
        if (!linkUrl || !linkUrl.length) {
            return this.getComponents();
        }
        if (this.name === "email") {
            linkUrl = `mailto:${linkUrl}`;
        }
        const title = linkUrl.startsWith("cb:") ? undefined : linkUrl;
        const { callbacks, allowLocal } = this.renderer.options;
        return (React.createElement(ErrorContext.Consumer, null, (context) => (React.createElement("a", { href: linkUrl, 
            // tslint:disable-next-line:jsx-no-lambda
            onClick: context.safeCB((evt) => this.clicked(evt, callbacks, allowLocal), [this.renderer.options]), title: title }, this.getComponents()))));
    }
    clicked = (evt, callbacks, allowLocal) => {
        evt.preventDefault();
        const uri = evt.currentTarget.href;
        let parsed;
        try {
            parsed = new URL(uri);
        }
        catch {
            // Invalid URL, don't handle it
            return;
        }
        const protocols = allowLocal
            ? ["http:", "https:", "file:"]
            : ["http:", "https:"];
        if (parsed.protocol === "cb:" && callbacks?.[parsed.host] !== undefined) {
            try {
                if (parsed.pathname === "") {
                    callbacks[parsed.host]();
                }
                else {
                    const args = parsed.pathname
                        .slice(1)
                        .split("/")
                        .map((seg) => decodeURIComponent(seg));
                    callbacks[parsed.host](...args);
                }
            }
            catch (err) {
                throw new Error(`invalid callback url "${uri}"`);
            }
        }
        else if (protocols.includes(parsed.protocol)) {
            opn(uri).catch((err) => undefined);
        }
    };
}
export default LinkTag;
